export default "__VITE_ASSET__B4O6MWog__"